import React, { useCallback } from 'react';
import { Switch } from 'antd';

// utils
import { getNumberOfButtons } from './utils';

// components
import CTAButton from './CTAButton';

export default function CalltoAction({ ctaButtons, updateButtons, allow }) {
  // disable when the select option reach the max length to add in call to action section
  const checkToAvailableToAdd = useCallback(
    (format) => getNumberOfButtons(ctaButtons, format),
    [ctaButtons]
  );

  const urlButtons = ctaButtons?.filter((b) => b?.type === 'URL') ?? [];
  const hasUrlButtons = urlButtons.length > 0;

  const isTrackingEnabled = urlButtons.some(
    (b) =>
      b?.track_click === true ||
      (b?.track_click === undefined && b?.url?.includes('track_click'))
  );

  const handleTrackingToggle = (checked) => {
    if (!allow) return;
    urlButtons.forEach((b) => {
      updateButtons({ updateKey: 'update', id: b?.id, key: 'track_click', value: checked });
    });
  };

  return (
    <div className='w-full border-[0.08vw] border-[var(--card-border)] rounded-[0.4vw] px-[0.4vw] py-[0.5vw]'>
      <h3 className='text-[var(--contentText)] font-default weight-semibold'>
        Call to action
      </h3>
      {ctaButtons?.map((d, i) => {
        const isFlowButton = d?.type === "FLOW";
        return (
          <div
            key={`call-to-action-${i}`}
            className={`w-full my-[0.6vw] rounded-[0.4vw] last:mb-0 ${
              isFlowButton
                ? "flex flex-col gap-[0.6vw]"
                : "h-[3.5vw] flex items-center gap-[0.4vw]"
            }`}
          >
            <div className={isFlowButton ? "w-full" : "flex-1"}>
              <CTAButton
                data={d}
                allow={allow}
                index={i}
                checkToAvailableToAdd={checkToAvailableToAdd}
                updateButtons={updateButtons}
              />
            </div>
          </div>
        );
      })}
      {hasUrlButtons && (
        <div className='mt-[0.6vw] pt-[0.5vw] border-t-[0.08vw] border-[var(--card-border)]'>
          <div className='flex items-center gap-[0.5vw]'>
            <Switch
              size='small'
              checked={isTrackingEnabled}
              onChange={handleTrackingToggle}
              disabled={!allow}
            />
            <span className='font-sm weight-medium text-[var(--font-600)]'>
              Track URL clicks
            </span>
          </div>
          {isTrackingEnabled && (
            <p className='font-sm weight-medium text-[#F59E0B] mt-[0.3vw] pl-[1.5vw]'>
              We suggest turning off URL click tracking to show a proper website
              preview in WhatsApp. When enabled, our tracking link replaces your
              URL and WhatsApp may display our platform domain instead of your
              website image.
            </p>
          )}
        </div>
      )}
    </div>
  );
}
